module.exports = __webpack_public_path__ + "img/NO971227222.5f61d218.svg";